import unique from "lodash/uniq";
export default function classnames() {
  var ar = [];
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var arg = _args[_i];
    if (typeof arg === "string") {
      ar.push(arg);
    } else if (typeof arg === "object" && arg.hasOwnProperty("className")) {
      ar.push(arg.className);
    }
  }
  return unique(ar).join(" ");
}
//# sourceMappingURL=classnames.js.map